// extracted by mini-css-extract-plugin
export default {"box":"masterSparesListPage_box__0IodB"};